import ContentSwitcher from './ContentSwitcher';

export default ContentSwitcher;